import { ReactElement } from "react";
import styles from "./Separator.module.less";

export const Separator = (): ReactElement => {
	return (
		<hr className={styles.root}/>
	);
};
Separator.displayName = "Separator";
